import { ChangeDetectionStrategy, Component, effect, HostBinding, Input, signal, ViewChild } from '@angular/core';
import type { MenuItem } from 'primeng/api';
import type { Menu } from 'primeng/menu';
import * as FlatModels from '@medsurf/flat-models';

@Component({
    selector: 'medsurf-design-input-menu',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './menu.input.design.html',
    styleUrls: ['./menu.input.design.scss'],
    standalone: false
})
export class MenuInputDesign {
  @Input() formField = true;
  @Input({ required: true }) name!: string;
  @Input() label?: string;
  @Input() tooltipLabel?: string;
  @Input() buttonIconClass?: FlatModels.ButtonDesignModels.ButtonDefaultIcons;
  @Input() buttonInputClass: FlatModels.ButtonDesignModels.ButtonDesignClass = FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY;
  @Input() menuClass: FlatModels.PanelDesignModels.MenuDesignClass = FlatModels.PanelDesignModels.MenuDesignClass.DEFAULT;
  @Input() iconOpen: FlatModels.ButtonDesignModels.ButtonDefaultIcons = FlatModels.ButtonDesignModels.ButtonDefaultIcons.UP;
  @Input() iconClose: FlatModels.ButtonDesignModels.ButtonDefaultIcons = FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN;
	@Input() loadMenuItems?: ((ctx: FlatModels.ActionMenusAuthorModels.MenuItemsAction) => MenuItem[] | undefined);
	@Input() loadContext: FlatModels.ActionMenusAuthorModels.MenuItemsAction;
	@Input() items: MenuItem[] = [];
  
  @ViewChild('menu_content', { static: false }) menuElementRef!: Menu;
  @HostBinding('class.is-open') isOpenClass = false;
  
  isOpen = signal(false);
	loadedItems: MenuItem[] | null = null;

  constructor() {
    effect(() =>  this.isOpenClass = this.isOpen());
  }
	
	toggle(event: any) {
		if (this.loadMenuItems) {
      const menuItems = this.loadMenuItems(this.loadContext);
      if (menuItems) {
        this.loadedItems = menuItems;
      }
		}
    this.isOpen.set(!this.isOpen());
    this.menuElementRef.toggle(event);
  }

  hide() {
    this.isOpen.set(false);
  }
}
